import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { SocialHistoryRowData } from "./social-history-rows";

export type SocialHistoryTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
  isRowViewed?: (row: TableRow) => boolean;
};

export function SocialHistoryTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Social History",
  isRowViewed,
}: SocialHistoryTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  const columns: ColumnDef<SocialHistoryRowData>[] = useMemo(
    () => [
      { key: "observation", header: "Observation" },
      { key: "value", header: "Value" },
      { key: "date", header: "Date", sort: "desc", width: "150px" },
    ],
    []
  );

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as SocialHistoryRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
